import { useEffect } from 'react';

import { useLocation } from 'react-router';
import { useHistory } from 'react-router-dom';

import get from 'lodash.get';
import qs from 'query-string';

const useLoggedoutAction = (
  toggle: () => void,
  action: string,
  currentValue: boolean = false,
  skip?: boolean
) => {
  const history = useHistory();
  const location = useLocation();

  const hasAction =
    get(qs.parse(decodeURIComponent(location.search)), 'action') === action;

  useEffect(() => {
    if (hasAction && !currentValue && !skip) {
      toggle();
    }

    if (hasAction && !skip) {
      history.push({
        search: '',
      });
    }
  }, [hasAction, skip]);

  return null;
};

export default useLoggedoutAction;
